export default "__VITE_ASSET__dDBQgFn___"